import React from "react"
import { AuthProvider } from "../contexts/AuthContext"
import { BrowserRouter as Router, Switch, Route } from "react-router-dom"
import Dashboard from "./Dashboard"
import PrivateRoute from "./authentication/PrivateRoute"
import AdminRoute from "./authentication/AdminRoute"
import BecarioRoute from "./authentication/BecarioRoute"

// import Signup from "./authentication/Signup"
import Login from "./authentication/Login"
import Admin from "./Admin"
import Becarios from "./Becarios"
import Pendientes from "./Pendientes"
import Reset from "./Reset"
import Checkin from "./Checkin"
import Update from "./Update"
import NewUser from "./NewUser"
import Registration from "./Registration"
import UserList from "./UserList"

function App() {
  return (
    // <CenteredContainer>
    <AuthProvider>
      <Router>
        <Switch>
          <PrivateRoute exact path='/' component={Registration} />
          {/* <PrivateRoute exact path="/" component={Dashboard} /> */}

          <PrivateRoute exact path='/update' component={Update} />
          <PrivateRoute exact path='/newuser' component={NewUser} />
          {/* <Route path="/signup" component={Signup}/> */}
          <Route path='/login' component={Login} />
          {/* <Route path="/admin" component={Admin}/> */}
          <BecarioRoute exact path='/admin' component={Admin} />
          <BecarioRoute exact path='/admin/pendientes' component={Pendientes} />
          {/* <AdminRoute exact path='/reset' component={Reset} /> */}
          <AdminRoute exact path='/admin/users' component={UserList} />

          <AdminRoute exact path='/admin/becarios' component={Becarios} />

          {/* <BecarioRoute exact path='/checkin' component={Checkin} /> */}
        </Switch>
      </Router>
    </AuthProvider>
    // </CenteredContainer>
  )
}
export default App
